module.exports = __webpack_public_path__ + "img/UnityFrameworkPathToolCamera.90c96583.gif";